import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1be2c7c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-plus add-agents-icon" }, null, -1))
const _hoisted_3 = { class: "add-agents-title" }
const _hoisted_4 = { class: "row" }

import { IncrediButton, IncrediTooltip, useIncrediDialog } from 'incredi-ui';
import AddAgentsForFreeDevLicenseDialog from '@/components/common/dialogs/AddAgentsForFreeDevLicenseDialog.vue';
import { onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'add-agents-free-dev',
  setup(__props) {

const showTooltip = ref(false);
const dialog = useIncrediDialog();
const openAddAgentsDialog = () => {
  dialog?.open('addAgentsForFreeDevLicenseDialog', AddAgentsForFreeDevLicenseDialog, {});
};

onUnmounted(() => {
  dialog?.close('addAgentsForFreeDevLicenseDialog');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IncrediTooltip), {
    modelValue: showTooltip.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showTooltip).value = $event)),
    hover: "",
    direction: "top-sticky-right",
    "offset-x": 0,
    "offset-y": 4,
    delay: 200
  }, {
    content: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('settings.dialogs.addAgentsForFreeDevLicense.title')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(IncrediButton), {
        design: "primary-green",
        size: "small",
        class: "text-[13px] text-center font-gordita-medium",
        "data-testid": "add-agents-for-free-dev-license-button",
        onClick: openAddAgentsDialog
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('settings.dialogs.addAgentsForFreeDevLicense.title')), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})